import { IAppInsightsSettings } from "../../settings/types/IAppInsightsSettings";
import axiosInstance from "../../setupAxios"

export class AppSettingsService {
    
    public static async getAppInsightsSettings(): Promise<IAppInsightsSettings> {
        const response = await axiosInstance.get("AppSettings/AppInsightsSettings");
        return response.data;
    }
}